import Text from 'components/Text/Text';
import React, { useContext, useEffect } from 'react';
import { Form } from 'antd';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import FileTypeSelect from './components/FileTypeSelect';
import MessageSelect from './components/MessageSelect';
import ParamsField from './components/ParamsField';
import BtnBlock from './components/BtnBlock';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from 'modules/Devices/DeviceFullInfo/deviceFullInfoState/deviceFullInfoContext';
import classNames from 'classnames';
import { preventDefaultForEnterKey } from 'utils/helpers';
import style from './DropboxPushModal.module.scss';

interface IDropboxPushModal {
	onFailureEvent: () => void;
	isVisible: boolean;
}

const DropboxPushModal: React.FC<IDropboxPushModal> = ({ isVisible, onFailureEvent }) => {
	const {
		changeTypeOfModalWindow,
		setDropboxPushFileType,
		setDropboxPushMessage,
		changeDropboxPushParams,
		setDataForPush,
		deviceForFullInfo,
		selectedDropboxPushFileType,
		selectedDropboxPushMessage,
		dropboxPushParams,
	} = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ selectedDropboxPushFileType });
		form.setFieldsValue({ selectedDropboxPushMessage });
		form.setFieldsValue({ dropboxPushParams });
	}, [selectedDropboxPushFileType, selectedDropboxPushMessage, dropboxPushParams]);

	const submit = () => {
		if (
			deviceForFullInfo?.restaurantId &&
			deviceForFullInfo.hardwareId &&
			selectedDropboxPushFileType &&
			selectedDropboxPushMessage
		) {
			const { restaurantId, hardwareId } = deviceForFullInfo;
			changeTypeOfModalWindow('confirm');
			setDataForPush({
				hardwareId,
				data: {
					restaurantId,
					notificationType: selectedDropboxPushMessage,
					fileType: selectedDropboxPushFileType,
					params: dropboxPushParams,
				},
			});
		}
	};

	return (
		<div className={containerClasses} data-test="DropboxPushModal">
			<div className={style.wrapper}>
				<div className={style.closeIconWrapper} onClick={onFailureEvent}>
					<svg className={style.closeIcon}>
						<use xlinkHref={`${breadcrumbs}#resetIcon`} />
					</svg>
				</div>
				<Text
					className={style.title}
					translationNameSpace="form"
					translationKey="dropboxPushManagementTitle"
					size="xxl"
					weight="bold"
				/>
				<div className={style.content}>
					<Form
						form={form}
						name="basic"
						onFinish={submit}
						onKeyPress={preventDefaultForEnterKey}
						layout="vertical">
						<div className={style.fieldsWrapper}>
							<Text
								translationNameSpace="form"
								translationKey="mainInfoHeading"
								theme="secondary"
								size="l"
								weight="bold"
								display="inline"
							/>
							<div className={style.row}>
								<FileTypeSelect setDropboxPushFileType={setDropboxPushFileType} />
								<MessageSelect setDropboxPushMessage={setDropboxPushMessage} />
							</div>
							<ParamsField changeDropboxPushParams={changeDropboxPushParams} />
						</div>
						<BtnBlock />
					</Form>
				</div>
			</div>
		</div>
	);
};

export default DropboxPushModal;
